module.exports = __webpack_public_path__ + "static/img/mobiletip.2d42c72.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/mobiletip.png
// module id = F3ab
// module chunks = 1